import {getUserNameFromTagId} from "./tools";
import {Box, Flex} from "@chakra-ui/react";
import React from "react";
import {TwitterTimelineEmbed} from "react-twitter-embed";
import {HeaderSection} from "../mainPage/HeaderSection";

const TagTimeline = ({tagId})=>{
    const username = getUserNameFromTagId(tagId)

    return <Box>
        <HeaderSection  text={"Suivre son activité en ligne"} flexGrowRight={18} />
        <Flex flexWrap={"wrap"} justifyContent={"flex-start"}>
        <Box minHeight={"400px"} width={["100%","100%","400px"]} m={[2,2,3]}  p={[1,2,3]} boxShadow={"card"} bg={"white"} borderRadius={"8px"}>
        <TwitterTimelineEmbed
      options={{
        height: 400
      }}
      screenName={username}
      sourceType="url"
      lang='fr'
      transparent
    /></Box>
        <Box  minHeight={"400px"} width={["100%","100%","400px"]} m={[2,2,3]}  p={[1,2,3]} boxShadow={"card"} bg={"white"} borderRadius={"8px"}>
             <TwitterTimelineEmbed
      options={{
        height: 400
      }}
      screenName={username}
      sourceType="likes"
      lang='fr'
      transparent
    />
        </Box>

    </Flex>

    </Box>

}


export default TagTimeline